"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JAPAN_TIME_OFFSET = 9;
exports.default = {
    JAPAN_TIME_OFFSET: JAPAN_TIME_OFFSET,
};
